'use strict';

jQuery(function ($) {

  const header = $('#header');
  const root = document.documentElement;

  function calcHeaderHeight() {
    var stickyHeight = header.outerHeight();
    root.style.setProperty('--header-height', stickyHeight + 'px');
    $('body').addClass('has-header-height');
  }

  function calcHeights() {
    calcHeaderHeight();
  }

  $(document).ready(function () {

    calcHeights();

    window.addEventListener('resize', calcHeights);

    var topNav = $('#top-menu');

    $('#nav-toggle').click(function (e) {
      $('body').toggleClass('menu-open');
      $('#header .menu-wrapper').removeClass('submenu-open');
      $('.sub-menu-container', topNav).removeClass('active');
    });

    $('li.menu-item-has-children > a', topNav).click(function (e) {
      if ($(window).width() < 1350) {
        $('.sub-menu-container', topNav).removeClass('active');
        $(this).siblings('.sub-menu-container').addClass('active');
        $(this).parents('.menu-wrapper').addClass('submenu-open');
      }
    });

    $('.back-bar', topNav).click(function (e) {
      e.preventDefault();
      $(this).parents('.menu-wrapper').removeClass('submenu-open');
    });

    setTimeout(function () {
      if ($('.st-default-search-input').val() === '') {
        $('.st-ui-container.st-ui-container-overlay').addClass('empty');
      }

    }, 1000);

    $(document).on('keyup', '.st-default-search-input', function (e) {
      if (e.key === 'Enter' && $('.st-ui-container.st-ui-container-overlay').hasClass('empty')) {
        $('.st-ui-container.st-ui-container-overlay').removeClass('empty');
      }
    });

    $('.search-toggle').on('click', function (e) {
      e.preventDefault();
      $('.st-ui-embed').show();
      $('.st-ui-embed input').focus();
      $(document).on('keyup', hideSearchEscape);
      setTimeout(function () {
        $(document).on('click', hideSearchClick);
      }, 500);
    });

    function hideSearchEscape(e) {
      if (e.key === 'Escape') {
        $('.st-ui-embed').hide();
        $(document).off('keyup', hideSearchEscape);
      }
    }

    function hideSearchClick(e) {
      let $target = $(e.target);
      if (!$target.closest('.st-ui-container').length) {
        $('.st-ui-embed').hide();
        $(document).off('click', hideSearchClick);
      }
    }

    var flipCards = $('.ontinue-flip-cards');

    if (flipCards.length) {
      $('.card', flipCards).click(function (e) {
        $(this).toggleClass('active');
      });
    }

    var awardsRibbon = $('.awards-ribbon');

    if (awardsRibbon.length) {
      $('.award', awardsRibbon).clone().appendTo('.awards', awardsRibbon);
      $('.award', awardsRibbon).clone().appendTo('.awards', awardsRibbon);

      $('.awards', awardsRibbon).css('--award-width', $('.award', awardsRibbon).outerWidth() + 'px');
      $('.awards').css('--animation-duration-horizontal', Math.round($('.awards', awardsRibbon).outerWidth() / 150) + 's');
      $('.awards').css('--animation-duration-vertical', Math.round($('.awards', awardsRibbon).outerHeight() / 150) + 's');
      window.addEventListener('resize', function () {
        $('.awards', awardsRibbon).css('--award-width', $('.award', awardsRibbon).outerWidth() + 'px');
        $('.awards').css('--animation-duration-horizontal', Math.round($('.awards', awardsRibbon).outerWidth() / 150) + 's');
        $('.awards').css('--animation-duration-vertical', Math.round($('.awards', awardsRibbon).outerHeight() / 150) + 's');
      });

      $('.awards', awardsRibbon).addClass('animate');
    }

    var drawers = $('.ontinue-drawers');

    if (drawers.length) {
      $('.tab', drawers).click(function (e) {
        if ($(this).hasClass('active')) { return false; }
        $('.tab, .tab-content', drawers).removeClass('active');
        $(this).addClass('active');
        $('#' + $(this).data('tab')).addClass('active');
      });
    }

    var quoteCarousel = $('.ontinue-quote-carousel');
    if (quoteCarousel.length) {
      $(quoteCarousel).each(function (i, el) {
        $('.carousel', el).slick({
          infinite: true,
          // slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true,
          mobileFirst: true,
          dots: true,
          appendDots: $('.slick-dots-mobile', el),
          slide: '.slide',
          centerMode: true,
          centerPadding: '0px',
          prevArrow: $('.slick-prev', el),
          nextArrow: $('.slick-next', el),
          // appendArrows: $('.slick-nav', el),
          responsive: [{
            breakpoint: 768,
            settings: {
              appendDots: $('.slick-dots-desktop', el),
              // appendArrows: $('.carousel .slick-nav', el)
            }
          }]
        });
        $('.carousel', el).css('--carousel-height', $('.carousel', el).outerHeight() + 'px');
        window.addEventListener('resize', function () {
          $('.carousel', el).css('--carousel-height', $('.carousel', el).outerHeight() + 'px');
        });
      });
    }

    var logosCarousel = $('.ontinue-logos-carousel');
    if (logosCarousel.length) {
      $(logosCarousel).each(function (i, el) {
        $('.carousel', el).slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          // rows: 3,
          // slidesPerRow: 1,
          // variableWidth: true,
          mobileFirst: true,
          dots: true,
          // slide: '.slide',
          prevArrow: '<span class="slick-prev">Previous</span>',
          nextArrow: '<span class="slick-next">Next</span>',
          // appendArrows: $('.slick-nav', el),
          responsive: [
            {
              breakpoint: 460,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                // rows: 2,
                // slidesPerRow: 2,
                dots: true
              }
            },
            {
              breakpoint: 655,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                // rows: 1,
                // slidesPerRow: 1,
                dots: true
              }
            },
            {
              breakpoint: 850,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                // rows: 1,
                // slidesPerRow: 1,
                dots: false
              }
            },
            {
              breakpoint: 1045,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                // rows: 1,
                // slidesPerRow: 1,
                dots: false
              }
            },
            {
              breakpoint: 1240,
              settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
                // rows: 1,
                // slidesPerRow: 1,
                dots: false
              }
            }
          ]
        });
      });
    }

    var resourcesCarousel = $('.ontinue-resources-carousel');
    if (resourcesCarousel.length) {
      $(resourcesCarousel).each(function (i, el) {
        $('.carousel', el).slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          dots: true,
          slide: '.slide',
          prevArrow: '<span class="slick-prev">Previous</span>',
          nextArrow: '<span class="slick-next">Next</span>',
          appendArrows: $('.slick-nav', el),
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: false
              }
            }
          ]
        });
      });
    }

    var newsCarousel = $('.ontinue-news-carousel');
    if (newsCarousel.length) {
      $(newsCarousel).each(function (i, el) {
        $('.carousel', el).slick({
          infinite: false,
          rows: 3,
          slidesPerRow: 1,
          mobileFirst: true,
          dots: true,
          prevArrow: '<span class="slick-prev">Previous</span>',
          nextArrow: '<span class="slick-next">Next</span>',
          appendArrows: $('.slick-nav', el),
          responsive: [
            {
              breakpoint: 600,
              settings: {
                rows: 2,
                slidesPerRow: 2,
                dots: false
              }
            }
          ]
        });
      });
    }

    var overlay = $('.md-overlay');

    $('.md-trigger').each(function (i, el) {
      var modal = $('#' + el.getAttribute('data-modal')),
        close = $('.md-close', modal);

      function removeModal(hasPerspective) {
        $(modal).removeClass('md-show');

        if (hasPerspective) {
          $(document).removeClass('md-perspective');
        }
      }

      function removeModalHandler() {
        removeModal($(el).hasClass('md-setperspective'));
      }

      $(el).click(function (ev) {
        $(modal).addClass('md-show');
        $(overlay).off('click', removeModalHandler);
        $(overlay).on('click', removeModalHandler);

        if ($(el).hasClass('md-setperspective')) {
          setTimeout(function () {
            $(document).addClass('md-perspective');
          }, 25);
        }

        $(close).on('click', function (ev) {
          ev.stopPropagation();
          removeModalHandler();
        });

      });


    });

    // Resource center
    if ($('.ontinue-resource-center').length > 0) {
      let $module = $('.ontinue-resource-center');

      $(window).on('click', function (e) {
        let $target = $(e.target);
        if (!$target.closest('.resource-filters-filter').length && !$target.is('a.eyebrow.filter-by') && $('.resource-filters-filter').is(':visible')) {
          $('.resource-filters-filter').slideUp();
          $('#resource-filter-overlay').remove();
          $module.find('.eyebrow.filter-by').removeClass('open');
        }
        if (!$target.closest('.resource-filters-filter-sort').length && !$target.is('a.eyebrow.sort-by') && $('.resource-filters-filter-sort').is(':visible')) {
          $('.resource-filters-filter-sort').slideUp();
        }
      });

      function updateResourceCenterGrid(args) {
        let top = $module.offset().top - $('#header').outerHeight();
        console.log("scrolling");
        $('html, body').animate({
          scrollTop: top
        }, 250, 'linear').promise().then(function () {
          $module.find('.resources-none-found').hide();
          let resource_types = $module.find('input[data-taxonomy=ontinue_resource_type]:checkbox:checked').map(function () {
            return $(this).val();
          }).get();
          let resource_topics = $module.find('input[data-taxonomy=ontinue_resource_topic]:checkbox:checked').map(function () {
            return $(this).val();
          }).get();

          let data = {
            paged: args.paged,
            base: $module.find('.resources').data('base'),
            action: 'resource_center_grid',
            resource_types: resource_types,
            resource_topics: resource_topics,
            order: $module.find('.resource-filters-filter-sort a.active').data('sort')
          };

          if (1 === args.paged && 0 === resource_types.length && 0 === resource_topics.length) {
            $module.find('.featured-post').show();
          } else {
            $module.find('.featured-post').hide();
          }

          $.ajax({
            url: window.ontinueJs.ajaxUrl,
            type: 'POST',
            dataType: 'json',
            data: data,
          }).done(function (resp) {
            $module.find('.resources').empty().html(resp.posts);
            if (resp.none_found) {
              $module.find('.resources-none-found').show();
            } else {
              $module
                .find('.resources-pagination-inner')
                .empty()
                .html(resp.pagination);
            }
            args.url = decodeURI(args.url);
            window.history.pushState({}, '', args.url);
          });
        });
      }

      $module.on('click', '.page-numbers', function (e) {
        e.preventDefault();
        if ($(this).hasClass('disabled'))
          return false;
        let url = $(this).attr('href');
        let paged = $(this).text();
        if ($(this).hasClass('next') || $(this).hasClass('prev')) {
          let current = parseInt($module.find('span.current').text());
          if ($(this).hasClass('next'))
            paged = current + 1;
          else
            paged = current - 1;
        }

        updateResourceCenterGrid({
          paged: paged,
          url: url
        });

      });

      $module.on('click', '.resource-filters a.eyebrow', function (e) {
        e.preventDefault();
        let $link = $(this);
        let target = $(this).data('open');
        $module.find(target).slideToggle(function () {
          $link.toggleClass('open');

          if ($link.hasClass('filter-by')) {
            if ($link.hasClass('open')) {
              let $overlay = $('<div>').attr('id', 'resource-filter-overlay');
              $('body').append($overlay);
              if (!$module.data('sized')) {
                $module.data('sized', true);
                $module.css({ 'min-height': $module.find('.resource-filters-filter').outerHeight() });
              }
            } else {
              $('#resource-filter-overlay').remove();
            }
          }
        });
      });

      $module.on('click', 'ul li', function () {
        let $checkbox = $(this).find('input');
        $checkbox.attr('checked', !$checkbox.attr('checked'));
        $(this).toggleClass('active');
        let url = buildUrl();
        updateResourceCenterGrid({
          paged: 1,
          url: url
        });
      });

      function buildUrl() {
        let url = $module.find('.resources').data('full-base');
        let resource_types = $module.find('input:checkbox:checked').map(function () {
          return { name: $(this).attr('name'), val: $(this).val() };
        }).get();
        if (resource_types.length > 0)
          url += '?' + resource_types.map(function (el) {
            return el.name + '=' + el.val;
          }).join('&');
        return url;
      }

      $module.on('click', '.resource-filters-filter a', function (e) {
        e.preventDefault();
        $(this).parent().slideUp();
        $module.find('.eyebrow.filter-by').removeClass('open');
        $('#resource-filter-overlay').remove();
      });

      $module.on('click', '.resource-filters-applied span a', function (e) {
        e.preventDefault();
        let $link = $(this);
        let slug = $(this).data('slug');
        $module.find('input[data-slug=' + slug + ']').attr('checked', false);
        $module.find('input[data-slug=' + slug + ']').closest('li').removeClass('active');
        $link.parent().parent().remove();
        if ($module.find('.resource-filters-filter input:checked').length === 0) {
          $module.find('.resource-filters-applied').hide();
        }
        updateResourceCenterGrid({
          paged: 1,
          url: buildUrl()
        });
      });

      $module.on('click', '.resource-filters-applied > a', function (e) {
        e.preventDefault();
        $module.find('input').attr('checked', false);
        $module.find('input').closest('li').removeClass('active');
        $module.find('.resource-filters-applied').empty();
        updateResourceCenterGrid({
          paged: 1,
          url: buildUrl(),
        });
      });

      $module.on('click', '.resource-filters-filter-sort a', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active'))
          return;
        $module.find('.resource-filters-filter-sort a.active').removeClass('active');
        $(this).addClass('active');
        let sort = $(this).data('sort');
        updateResourceCenterGrid({
          paged: 1,
          url: buildUrl(),
          sort: sort
        });
        $module.find('.resource-filters-filter-sort').slideUp();
      });
    }

  });

  $(function () {
    // accordion panel
    // (Optional) Active an item if it has the class "is-active"	
    $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();

    $(".accordion > .accordion-item").click(function () {
      // Cancel the siblings
      $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
      // Toggle the item
      $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
    });

    // resource detail share link (copy to clipboard)
    if ($('.share-link').length > 0) {
      $('body').on('click', '.share-link', function (e) {
        e.preventDefault();
        let $link = $(this);
        if ($link.data('url')) {
          var copyText = $link.data('url');

          // Copy the text inside the text field
          navigator.clipboard.writeText(copyText);
          $link.addClass('clicked');
          setTimeout(() => {
            $link.removeClass('clicked');
          }, 2000);
        }
      });
    }

    // resource/event detail related articles
    if ($('.ontinue-related-articles').length > 0) {
      $('.ontinue-related-articles .ontinue-related-articles-inner').slick({
        mobileFirst: true,
        infinite: true,
        dots: true,
        prevArrow: $('.ontinue-related-articles-navigation div:first-child'),
        nextArrow: $('.ontinue-related-articles-navigation div:last-child'),
        appendDots: $('.ontinue-related-articles-navigation div:nth-child(2)'),
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        }]
      });
    }

    $('body').on('click', '.footer-scroll-to-top', function (e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 });
    });

    // data layer
    let dataLayerCounter = 0;
    let datalayerInterval = setInterval(function () {
      // console.log("Checking for gtag");
      if (window.hasOwnProperty('gtag')) {
        // console.log("Found gtag");
        clearInterval(datalayerInterval);
        initDataLayer();
      }
      dataLayerCounter++;
      if (50 === dataLayerCounter)
        clearInterval(datalayerInterval);
    }, 500);

    function initDataLayer() {
      try {
        function capitalizeFirstLetter(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
        }

        window.gtag('get', 'G-139L0H9P9W', 'client_id', function (client_id) {
          window.rddl.init(client_id, {
            // Optional parameters
            component_class: '',
            form_class: '',
            is_testing: false,
            is_logged_in: false,
            munchkin_id: '',
            segment_id: '',
            user_id: '',
          });


          // Terminus script setup
          function onRambleLoad() {
            Ramble.init({
              code: "10bcd1a441",
              realtimeUrl: "https://chat-team-management.terminus.services",
              fileStoreUrl: "https://di3c8wks3odob.cloudfront.net",
              resolveUTMVariables: true,
              onDataCaptured: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'data_captured',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid,
                  dataType: params.type,
                  dataValue: params.value
                });
              },
              onMeetingBooked: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'meeting_booked',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid,
                  email: params.email,
                  start_time_stamp: params.startTimestamp,
                  end_time_stamp: params.endTimestamp,
                  description: params.description
                });
              },
              onFirstVisitorInteraction: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'first_interaction',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid,
                  message: params.message
                });
              },
              onButtonClick: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'chat_open'
                });
              },
              onChatCompleted: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'Chat Complete',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid
                });
              },
              onChatRequested: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'Chat Requested',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid
                });
              },
              onChatMessage: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'Message Sent',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid,
                  message: params.message,
                  messageType: params.messageType
                });
              }
            });
          }
          function lr(e) { console.error("Unable to load ramble snippet: " + e.message); }; var s = document.createElement("script"); s.onerror = lr; s.onload = onRambleLoad; document.head.appendChild(s); s.async = true; s.src = "https://chat-snippet.terminusplatform.com/ramble.snippet.js";

          if ($('.ontinue-contact-grid').length > 0) {
            window.rddl.click('a[href^="tel:"], a[href^="mailto:"]',
              {
                event: 'contactClick',
                linkText: 'link.text',
                linkURL: 'link.url'
              }
            );
          }

          window.rddl.click('.ontinue-sidebar-social a',
            {
              event: 'socialShare',
              socialPlatform: 'link.data.socialPlatform'
            }
          );

          // Store the location (header, body, footer) for each a.button element as a data attribute so that it
          // can be sent with the event
          ['header', 'main', 'footer'].forEach(function (loc) {
            $(loc).find('a.button').each(function () {
              let location = capitalizeFirstLetter('main' === loc ? 'body' : loc);
              $(this).attr('data-location', location);
            });
          });

          // cta click
          window.rddl.click('a.button:not([href^="tel:"]):not([href^="mailto:"])',
            {
              event: 'ctaButton',
              linkText: 'link.text',
              linkURL: 'link.url',
              linkLocation: 'link.data.location', // Location of the CTA button (Header, Body or Footer)
            }
          );

          // marketo form start
          window.rddl.marketo('start', {
            event: 'formStart',
            formID: 'form.marketo_form_id',
            formField: 'form.field_start',
          }, 'click');

          // marketo form submit
          window.rddl.marketo('submit', {
            event: 'formSubmit',
            userID: 'form.fields_filled_hashed.Email', // Hash the email address
            formID: 'form.marketo_form_id', // Marketo Form ID
          }, 'mktoForm');



          // Top nav clicks
          $('#menu-top-menu > li').each(function () {
            let category = $(this).find('> a').text();
            $(this).find('.sub-menu li a').attr('data-category', category);
          });
          window.rddl.click('#menu-top-menu .sub-menu li a', {
            event: 'navigation',
            linkText: 'link.text',
            linkURL: 'link.url',
            linkCategory: 'link.data.category',
          });
        });
      } catch (e) {
        console.error('An error has occurred: ', e);
      }
    }
  });


});